<template>
  <DxPopup
    :visible="getVisible"
    @hidden="onPopupHide"
    @shown="onShown"
    :drag-enabled="false"
    :hide-on-outside-click="false"
    :show-close-button="false"
    :show-title="true"
    :width="'95%'"
    :height="700"
    :title="getTitle"
    :wrapper-attr="{
      class: 'css-v2 gc-popup gc-popup-work-order-release-model',
    }"
    ref="gc-popup"
  >
    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
    />

    <div class="css-v2 gc-popup-form">
      <gc-form
        :key="1"
        :form-options="{
          gcLabelLocation: 'left',
        }"
        ref="gc-header-form"
        :form-items="getHeaderFormItems"
        :is-normal="true"
        :data-model="getFormModel"
        :form-mode="popupMode"
        :from-from="'gc-header-form-d-a'"
        :form-height="35"
        v-if="loaded"
        :formContentReady="formContentReady"
      />

      <div class="data-grid" v-if="loaded">
        <dx-data-grid
          v-if="getVisible"
          :columnChooser="{
            enabled: false,
          }"
          :pager="{ visible: false }"
          :paging="{
            enabled: false,
          }"
          :columns="getColumns"
          :data-source="getDataSourceConfig"
          :row-alternation-enabled="true"
          :focusedRowEnabled="popupMode === 'create'"
          :height="getGridHeight"
          :width="'100%'"
          @editor-preparing="onEditorPreparing"
          @editing-start="onEditingStart"
          :ref="'gc-popup-release-model-grid'"
          @row-removed="onRowRemoved"
          @saved="onSaved"
          @cell-prepared="onCellPrepared"
          :repaint-changes-only="true"
          :two-way-binding-enabled="false"
        >
          <DxSearchPanel :visible="false" />
          <DxKeyboardNavigation
            :edit-on-key-press="true"
            :enter-key-action="'startEdit'"
            :enter-key-direction="'none'"
            :enabled="popupMode === 'create'"
          />

          <DxEditing
            :allow-deleting="popupMode === 'create'"
            :allow-updating="popupMode === 'create'"
            :mode="'cell'"
            :changes="changes"
            :confirm-delete="false"
          />

          <template #location-search>
            <div>
              <DxButton
                :text="''"
                icon="find"
                type="default"
                styling-mode="contained"
              />
            </div>
          </template>

          <template #Decimal="{ data }">
            <GcDecimal :dataValue="data" :format="data.column.format" />
          </template>

          <DxMasterDetail :enabled="true" template="masterDetailTemplate" />
          <template #masterDetailTemplate="{ data: lineItem }">
            <dx-data-grid
              :columns="getChildGridColumns"
              :data-source="getBatchDataSourceConfig(lineItem)"
              :columnChooser="{
                enabled: false,
              }"
              :searchPanel="{
                visible: false,
              }"
              :pager="{ visible: false }"
              :ref="'master-details-' + lineItem.data.ID"
              :key="'master-details-' + lineItem.data.ID"
              :elementAttr="{ class: 'internal-grid' }"
              :row-alternation-enabled="true"
              :focusedRowEnabled="popupMode === 'create'"
              @selectionChanged="onSelectionChanged"
              @editor-preparing="onBatchEditorPreparing"
              @contentReady="onBatchContentReady"
            >
              <DxSelection
                :select-all-mode="'allPages'"
                :show-check-boxes-mode="'always'"
                :mode="popupMode === 'create' ? 'multiple' : 'none'"
                :allowSelectAll="true"
              />

              <DxEditing
                :allow-deleting="false"
                :allow-updating="popupMode === 'create'"
                :mode="'cell'"
                :confirm-delete="false"
              />

              <template #Decimal="{ data }">
                <GcDecimal :dataValue="data" :format="data.column.format" />
              </template>
            </dx-data-grid>
          </template>
        </dx-data-grid>
      </div>
      <gcPopupStorageLocationList
        :popupConfig="slPopupConfig"
        :add-selected-sl-lines="addSelectedStorageLocation"
        v-if="slPopupConfig.visible"
      />
    </div>
  </DxPopup>
</template>

<script>
import ArrayStore from "devextreme/data/array_store";
import { getActiveAccountPeriod } from "../../_helpers/default-value-rules/default-value-rules";
import { ProductionReleaseService } from "../../_services/api/production/production-release.service";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import SettingsService from "../../_services/api/settings/graycorp/settings.service";
import { forwardTabbing } from "@/_helpers/ui/keyboard";

import { mapGetters } from "vuex";
import { MaterialIssuesService } from "../../_services/api/production/material-issues.service";
import { FeatureStorage } from "../../_services/storage";

import DataGridHelpers from "@/_helpers/data-grid/helpers";
const { countLineBreaks } = DataGridHelpers;
import GcPopupStorageLocationList from "../gc-popup-storage-location-list.vue";
import { ProductAttributeService } from "../../_services/api/settings/products/product-attribute.service";
import { backwardTabbing, onEnter } from "../../_helpers/ui/keyboard";
import { getDefaultDateSettings } from "../../_store/helpers";
import { formatNumber } from "devextreme/localization";

let baseLine = {
  WorkOrderCode: null,
  ProcessCode: null,
  IssueType: null,
  IssueTypeRecordId: null,
  BinCardNo: null,
  SeasonYear: null,
  BinLocationCode: null,
  ProductCode: null,
  ProductDescription: null,
  StockUMQty: 0,
  StockUM: null,
  Comment: null,
  Completed: false,
  IsBatchProduct: "No",
  ChildDataSource: new ArrayStore({
    key: "ID",
    data: [],
  }),
};

// let batchLine = {
//   ID: null,
//   BatchNo: null,
//   SupplierCode: null,
//   SupplierName: null,
//   BestBeforeDate: null,
//   UseByDate: null,
//   ExpiryDate: null,
//   AvailableQty: 0,
//   IssuedQty: 0,
//   InTransactionQty: 0,
//   RemainingQty: 0,
// };

export default {
  components: { GcPopupStorageLocationList },
  props: {
    popupConfig: {
      type: Object,
      default: () => {},
    },
    onHide: {
      type: Function,
      default: () => [],
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    popupMode: {
      type: String,
      default: "create",
    },
  },
  data() {
    return {
      model: {
        IssueDate: new Date(),
        BranchCode: undefined,
      },
      loaded: false,
      DateMin: undefined,
      DateMax: undefined,
      issueDataSource: new ArrayStore({
        key: "ID",
        data: [],
      }),
      changes: [],

      ProductionReleasePalletVisibility: undefined,
      ProductionReleasePalletRequired: undefined,
      ProductionReleaseAutoGeneratedPallet: undefined,
      IsWorkOrderEditable: true,
      FocusedOnHeaderForm: false,
      WorkOrderInstance: "Core",
      slPopupConfig: {
        visible: false,
        dataModel: {},
      },
      ignoreLocationChangeEvent: false,
      currentFiscalYear: null,
      AlmondcoMaterialIssuesAttributeFilter: null,
      LineCellErrorVisible: false,
      BatchGridInstance: null,
      reversalInitiated: false,
      batchSelectionPromise: null,
    };
  },
  async created() {
    await this.getProductionReleasesSettings();

    if (this.popupMode === "create") {
      await this.setMaterialIssuesAttributeFilter();
      this.currentFiscalYear = getDefaultDateSettings().currentFiscalYear;
      await this.getDefaultIssueType();
      const datePeriod = await getActiveAccountPeriod();
      this.DateMin = datePeriod.DateMin;
      this.DateMax = datePeriod.DateMax;

      if (this.model.IssueDate < this.DateMin) {
        this.model.IssueDate = new Date(this.DateMin);
      } else if (this.model.IssueDate > this.DateMax) {
        this.model.IssueDate = new Date(this.DateMax);
      }

      if (this.popupConfig.dataModel) {
        this.model = Object.assign(this.model, {
          ...this.popupConfig.dataModel,
        });

        if (this.popupConfig.dataModel.WorkOrderCode) {
          baseLine.WorkOrderCode = this.popupConfig.dataModel.WorkOrderCode;
          this.IsWorkOrderEditable = false;
        } else {
          baseLine.WorkOrderCode = null;
          baseLine.ProductCode = null;
          baseLine.ProductUM = null;
          baseLine.Conversion = 0;
          baseLine.StockUMConversion = 1;
          baseLine.PalletNo = null;
          baseLine.BatchNo = null;
          baseLine.ProductionUMQty = 0;
          baseLine.StockUMQty = 0;
          baseLine.Comment = null;
          baseLine.IsBatchProduct = "No";
          baseLine.PrimaryProductType = null;
          baseLine.Completed = false;
          baseLine.StorageLocationRecordId = null;
          baseLine.BinLocationCode = null;
          this.IsWorkOrderEditable = true;
        }
      }

      this.issueDataSource.insert(baseLine);
    } else {
      await this.getMaterialIssueHeader();
    }

    this.$nextTick(() => {
      this.loaded = true;
    });
  },
  methods: {
    async getDefaultIssueType() {
      try {
        const response = await MaterialIssuesService.getDefaultIssueType(
          this.WorkOrderInstance
        );

        if (response && response.data && response.data.value.length > 0) {
          const defaultIssueType = response.data.value[0];
          baseLine.IssueType = defaultIssueType.MaterialIssueTypeName;
          baseLine.IssueTypeRecordId = defaultIssueType.RecordId;
        }
      } catch (error) {
        this.displayServerErrorOnTemplate(
          error,
          "Unable to load default issue type."
        );
      }
    },

    async getMaterialIssueHeader() {
      try {
        const response = await MaterialIssuesService.getMaterialIssueHeader(
          this.popupConfig.dataModel.IssueNo
        );

        if (
          response &&
          response.data &&
          response.data.value &&
          response.data.value.length > 0
        ) {
          const issue = response.data.value[0];
          this.model.IssueDate = new Date(issue.DateIn.replace("Z", ""));
          this.model.BranchCode = issue.BranchCode;
        }
      } catch (error) {
        this.displayServerErrorOnTemplate(
          error,
          "Unable to load material issue header."
        );
      }
    },

    displayServerErrorOnTemplate(err, msg) {
      this.$store.dispatch("ui/setServerError", {
        error: err,
        title: msg,
      });
    },
    async getProductionReleasesSettings() {
      await SettingsService.getBySettingByApplicationFeatureCode(
        "WorkOrder"
      ).then((res) => {
        res.data.value.forEach((element) => {
          if (element.SettingName == "ProductionReleasePalletVisibility") {
            this.ProductionReleasePalletVisibility = element.SettingValue;
          } else if (element.SettingName == "ProductionReleasePalletRequired") {
            this.ProductionReleasePalletRequired = element.SettingValue;
          } else if (
            element.SettingName == "ProductionReleaseAutoGeneratedPallet"
          ) {
            this.ProductionReleaseAutoGeneratedPallet = element.SettingValue;
          } else if (element.SettingName == "ProductionReleasePalletAi") {
            this.ProductionReleasePalletAi = element.SettingValue;
          } else if (element.SettingName == "WorkOrderInstance") {
            if (element.SettingValue) {
              this.WorkOrderInstance = element.SettingValue;
            }

            // this.WorkOrderInstance = "Almondco"; // Default to Almondco for now
          }
        });

        // console.log("WorkOrderInstance ", this.WorkOrderInstance);
      });
    },

    async setMaterialIssuesAttributeFilter() {
      let settingValue = await SettingsService.getBySettingName(
        "AlmondcoMaterialIssuesAttributeFilter"
      );

      if (settingValue.data.value.length > 0) {
        const SettingValue = settingValue.data.value[0].SettingValue;
        let setFilter = [];

        if (SettingValue) {
          const categoryMap = {
            "Product Category 1": "ProductCategory1Code",
            "Product Category 2": "ProductCategory2Code",
            "Product Category 3": "ProductCategory3Code",
            "Product Category 4": "ProductCategory4Code",
            "Product Type": "ProductTypeCode",
            "Product Size": "ProductSizeCode",
          };

          this.AlmondcoMaterialIssuesAttributeFilter =
            categoryMap[SettingValue];

          let FilterValues = await SettingsService.getBySettingName(
            "AlmondcoMaterialIssuesAttributeFilterValues"
          );

          if (FilterValues.data.value.length > 0) {
            const filterValue =
              FilterValues.data.value[0].SettingValue.split(",");

            if (categoryMap[SettingValue]) {
              for (const key in filterValue) {
                if (typeof filterValue[key] !== "string") {
                  continue;
                }
                if (setFilter.length > 0) {
                  setFilter.push("or");
                }
                setFilter.push([
                  categoryMap[SettingValue],
                  "=",
                  filterValue[key].trim(),
                ]);
              }
            } else {
              for (let i = 1; i <= 20; i++) {
                const formattedAttribute = `Attribute ${i
                  .toString()
                  .padStart(2, "0")}`;
                if (SettingValue === formattedAttribute) {
                  for (const key in filterValue) {
                    if (typeof filterValue[key] !== "string") {
                      continue;
                    }
                    if (setFilter.length > 0) {
                      setFilter.push("or");
                    }
                    setFilter.push([
                      formattedAttribute.replace(
                        /\bAttribute\s+(\d{1,2})/g,
                        "Attribute$1"
                      ),
                      "=",
                      filterValue[key].trim(),
                    ]);
                  }
                }
              }
            }
          }

          if (setFilter.length > 0) {
            this.AlmondcoMaterialIssuesAttributeFilter = setFilter;
          }
        } else {
          this.AlmondcoMaterialIssuesAttributeFilter = null;
        }
      }
    },

    async onPopupHide() {
      this.onHide();
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);

      if (this.reversalInitiated) {
        this.reversalInitiated = false;
        this.$emit("onRefreshDataList");
        this.$emit("onRefreshWorkOrderHeader");
      }
    },
    onShown() {
      this.$store.dispatch("hotKey/setHotKeyPopupMode", true);
    },

    async onPopupClose() {
      const confirmLeaving = await this.$confirm(
        "Do you want to discard the material issue creation?",
        "Unsaved changes"
      );
      if (confirmLeaving) {
        this.onHide();
      }
    },
    onEditorPreparing(e) {
      if (
        e.dataField &&
        (e.dataField == "WorkOrderCode" || e.dataField == "ProcessCode")
      ) {
        e.editorName = "dxSelectBox";
      }

      if (e.dataField && e.dataField == "Comment") {
        e.editorName = "dxTextArea";
      }

      if (e.parentType !== "searchPanel") {
        if (e.editorOptions && e.editorOptions.onFocusOut) {
          let func = e.editorOptions.onFocusOut;
          e.editorOptions.onFocusOut = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
        }

        if (e.editorOptions && e.editorOptions.onFocusIn) {
          let func = e.editorOptions.onFocusIn;
          e.editorOptions.onFocusIn = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
        }

        if (e.editorOptions && e.editorOptions.onValueChanged) {
          let func = e.editorOptions.onValueChanged;
          e.editorOptions.onValueChanged = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
        }

        if (e.editorOptions && e.editorOptions.onItemClick) {
          let func = e.editorOptions.onItemClick;
          e.editorOptions.onItemClick = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
        }

        if (e.editorOptions && e.editorOptions.onKeyDown) {
          let func = e.editorOptions.onKeyDown;
          e.editorOptions.onKeyDown = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
        }

        if (e.dataField === "BinLocationCode") {
          if (
            e.editorOptions &&
            e.editorOptions.buttons &&
            e.editorOptions.buttons.length > 0
          ) {
            const gridInstance = this.dataGrid; // assuming your DxDataGrid has ref="grid"

            e.editorOptions.buttons.forEach((button) => {
              if (button.name === "search") {
                const originalClick = button.options.onClick;

                button.options.onClick = (event) => {
                  // Traverse DOM to find the row element
                  const cell = event.event.target.closest(
                    ".dx-editor-cell, .dx-cell"
                  );
                  const rowElement = cell.closest(".dx-row");

                  let rowIndex = -1;
                  let rowData = null;

                  if (rowElement && gridInstance) {
                    const visibleRows = gridInstance.getVisibleRows();
                    const rowElements = gridInstance
                      .getScrollable()
                      .content()
                      .querySelectorAll(".dx-row");

                    rowElements.forEach((rowEl, i) => {
                      if (rowEl === rowElement) {
                        rowIndex = i;
                        rowData = visibleRows[i].data;
                      }
                    });
                  }

                  originalClick(event, {
                    column: {
                      dataField: e.dataField,
                    },
                    data: rowData,
                    rowIndex: rowIndex,
                  });
                };
              }
            });
          }
        }
      }
    },
    onBatchEditorPreparing(e) {
      if (e.parentType !== "searchPanel") {
        if (e.editorOptions && e.editorOptions.onKeyDown) {
          let func = e.editorOptions.onKeyDown;
          e.editorOptions.onKeyDown = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
        }

        if (e.editorOptions && e.editorOptions.onFocusOut) {
          let func = e.editorOptions.onFocusOut;
          e.editorOptions.onFocusOut = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
        }
      }
    },
    onBatchContentReady(e) {
      const dataGrid = e.component;
      const dataSource = dataGrid.getDataSource();
      const items = dataSource.items();

      let selectedRowIndexs = [];
      for (const item of items) {
        if (item.IsIncluded) {
          selectedRowIndexs.push(item.ID);
        }
      }

      if (selectedRowIndexs.length > 0) {
        dataGrid.selectRows(selectedRowIndexs, true);
      }
    },
    onEditingStart(e) {
      const rowData = e.data;
      if (rowData && this.popupMode === "create") {
        if (e.column.dataField) {
          if (
            !rowData.WorkOrderCode &&
            e.column.dataField !== "WorkOrderCode"
          ) {
            e.cancel = true;
          }
        }

        if (e.column.dataField === "IssueType") {
          if (!rowData.ProcessCode) {
            e.cancel = true;
          }
        }

        if (
          e.column.dataField === "BinCardNo" ||
          e.column.dataField === "SeasonYear" ||
          e.column.dataField === "BinLocationCode" ||
          e.column.dataField === "ProductCode"
        ) {
          if (!rowData.ProcessCode || !rowData.IssueType) {
            e.cancel = true;
          }
        }

        if (
          e.column.dataField === "StockUMQty" ||
          e.column.dataField === "Comment" ||
          e.column.dataField === "Completed"
        ) {
          if (!rowData.ProductCode) {
            e.cancel = true;
          }
        }

        if (
          (e.column.dataField === "StockUMQty" ||
            e.column.dataField === "Completed") &&
          rowData.IsBatchProduct !== "No"
        ) {
          e.cancel = true;
        }

        if (e.column.dataField === "BatchNo") {
          if (
            !rowData.ProductUM ||
            rowData.IsBatchProduct.toLowerCase() != "manual"
          ) {
            e.cancel = true;
          }
        }
      }

      if (rowData && this.popupMode !== "review") {
        // if (e.column.dataField === "BinCardNo") {
        //   if (rowData.IssueType === "Added In") {
        //     e.cancel = true;
        //   }
        // }

        if (e.column.dataField === "SeasonYear") {
          if (
            rowData.IssueType !== "Issue" &&
            rowData.IssueType !== "Added In"
          ) {
            e.cancel = true;
          }
        }

        if (
          e.column.dataField === "ProductCode" ||
          e.column.dataField === "StockUMQty" ||
          e.column.dataField === "BinLocationCode"
        ) {
          const isAlmondco = this.WorkOrderInstance === "Almondco";
          const isIssue = rowData.IssueType === "Issue";
          const isAddedInWithBin =
            rowData.IssueType === "Added In" && rowData.BinCardNo;

          if (isAlmondco && (isIssue || isAddedInWithBin)) {
            e.cancel = true;
          }

          if (
            isAlmondco &&
            isIssue &&
            !isAddedInWithBin &&
            !rowData.BinCardNo &&
            (e.column.dataField === "ProductCode" ||
              e.column.dataField === "StockUMQty")
          ) {
            e.cancel = false;

            if (e.column.dataField === "StockUMQty") {
              if (rowData.ProductCode && rowData.IsBatchProduct !== "No") {
                e.cancel = true;
              }
            }
          }
        }
      }
    },
    onCellPrepared(e) {
      if (e.rowType !== "data") return;

      if (e.rowType === "data" && e.column.command === "expand") {
        if (e.data.IsBatchProduct === "No") {
          if (e.cellElement && e.cellElement.classList) {
            e.cellElement.classList.remove("dx-datagrid-expand");
            e.cellElement.childNodes[0].classList.remove(
              "dx-datagrid-group-closed"
            );
          }
        }
      }

      const { data, column, cellElement } = e;
      const field = column.dataField;

      const requiredFields = {
        WorkOrderCode: !data.WorkOrderCode,
      };

      if (requiredFields[field]) {
        cellElement.classList.add("required-field");
      } else {
        cellElement.classList.remove("required-field");
      }
    },
    focusOnEditableCell(rowIndex, col) {
      const column = col ? col : "WorkOrderCode";
      const dataGrid = this.dataGrid;
      const cellElement = dataGrid.getCellElement(rowIndex, column);
      dataGrid.focus(cellElement);
      setTimeout(() => {
        dataGrid.editCell(rowIndex, column);
      }, 10);
    },
    formContentReady(e) {
      if (e && this.loaded && !this.FocusedOnHeaderForm) {
        this.FocusedOnHeaderForm = true;
        setTimeout(() => {
          var headerToolBarForm = e.component;
          if (headerToolBarForm && headerToolBarForm.getEditor("IssueDate")) {
            headerToolBarForm.getEditor("IssueDate").instance().focus();
          }
        }, 500);
      }
    },
    async onRowRemoved(e) {
      const dataField = this.IsWorkOrderEditable
        ? "WorkOrderCode"
        : "ProductCode";
      const items = await this.issueDataSource.load();
      if (items.length === 0) {
        this.issueDataSource.insert(baseLine);
        e.component.refresh();
        await this.$nextTick();

        setTimeout(() => {
          this.focusOnEditableCell(0, dataField);
        }, 100);
      } else {
        if (e.data && (!e.data.WorkOrderCode || !e.data.ProductCode)) {
          // this.issueDataSource.insert(baseLine);
          e.component.refresh();
          await this.$nextTick();

          setTimeout(() => {
            this.focusOnEditableCell(items.length, dataField);
          }, 100);
        }
      }

      this.resetTransactionQtyOnBatchLines(e.data);
    },
    async resetTransactionQtyOnBatchLines(data) {
      if (data) {
        if (data.IsBatchProduct != "No") {
          const batchItems = await data.ChildDataSource.load();
          const items = await this.issueDataSource.load({
            filter: [
              ["ProductCode", "=", data.ProductCode],
              "and",
              ["ID", "<>", data.ID],
              "and",
              ["IsBatchProduct", "<>", "No"],
            ],
          });
          for (const batch of batchItems) {
            if (items.length > 0) {
              for (const lineItem of items) {
                const batchDataItems = await lineItem.ChildDataSource.load({
                  filter: [
                    ["BatchNo", "=", batch.BatchNo],
                    "and",
                    ["SupplierCode", "=", batch.SupplierCode],
                  ],
                });

                if (batchDataItems.length > 0) {
                  lineItem.ChildDataSource.update(batchDataItems[0].ID, {
                    InTransactionQty:
                      batchDataItems[0].InTransactionQty - batch.IssuedQty,
                    RemainingQty:
                      batchDataItems[0].RemainingQty + batch.IssuedQty,
                  });
                }
              }
            }
          }
        }
        this.dataGrid.refresh();
        await this.$nextTick();
      }
    },
    async addCopyReleaseLine(e) {
      if (e.event) {
        const data = e.row.data;

        if (!data.WorkOrderCode || !data.ProductCode) {
          await this.$alert(
            "Please select a work order and product before copying.",
            "Validation Error"
          );
          if (!data.WorkOrderCode) {
            this.focusOnEditableCell(e.row.rowIndex, "WorkOrderCode");
          } else {
            this.focusOnEditableCell(e.row.rowIndex, "ProductCode");
          }
          return;
        } else if (
          !data.PalletNo &&
          this.ProductionReleasePalletRequired === "Y" &&
          this.ProductionReleasePalletVisibility === "Y"
        ) {
          await this.$alert(
            "Please enter a pallet number before copying.",
            "Validation Error"
          );
          this.focusOnEditableCell(e.row.rowIndex, "PalletNo");
          return;
        } else if (
          !data.BatchNo &&
          data.IsBatchProduct.toLowerCase() === "manual"
        ) {
          await this.$alert(
            "Please enter a batch number before copying.",
            "Validation Error"
          );
          this.focusOnEditableCell(e.row.rowIndex, "BatchNo");
          return;
        } else if (data.ProductionUMQty <= 0 || data.StockUMQty <= 0) {
          await this.$alert(
            "Please enter valid quantities before copying.",
            "Validation Error"
          );
          if (data.ProductionUMQty <= 0) {
            this.focusOnEditableCell(e.row.rowIndex, "ProductionUMQty");
          } else {
            this.focusOnEditableCell(e.row.rowIndex, "StockUMQty");
          }
          return;
        } else {
          const newLine = { ...data };
          delete newLine.ID; // Remove ID to create a new record

          this.changes = [
            {
              type: "insert",
              data: newLine,
              insertAfterKey: e.row.key,
            },
          ];

          const dataGrid = this.dataGrid;
          dataGrid.clearSelection();
          dataGrid.option("focusedRowIndex", -1);

          this.$nextTick(() => {
            dataGrid.saveEditData();
            dataGrid.refresh();
          });
        }
      }
    },
    onSaved(e) {
      if (e.changes && e.changes.length > 0) {
        const change = e.changes[0];
        if (change.insertAfterKey !== undefined) {
          const element = change.data;
          let index = -1;

          index = this.issueDataSource._array.findIndex(
            (x) => x.ID === change.insertAfterKey
          );
          this.issueDataSource._array.splice(
            this.issueDataSource._array.length - 1,
            1
          );
          this.issueDataSource._array.splice(index + 1, 0, element);

          if (index !== -1)
            setTimeout(() => {
              this.focusOnEditableCell(index + 1, "WorkOrderCode");
            }, 100);
        }
      }
    },

    // Method to save the production release
    async onSaveProductionRelease() {
      await this.focusOutFromEditableCells();
      if (this.batchSelectionPromise) {
        await this.batchSelectionPromise;
      }
      await this.$nextTick();
      const payload = await this.getPayloadData();

      if (payload.MaterialIssueDetails.length === 0) {
        await this.displayLineCellError(
          "No material issues to save. Please add at least one material issue.",
          "Error"
        );

        this.$nextTick(() => {
          this.focusOnEditableCell(0, "WorkOrderCode");
        });
        return;
      }

      if (payload.ReconciliationErrors.length > 0) {
        await this.displayLineCellError(
          "The Batch Quantity for the following line(s) do not reconcile with the Issue Quantity. " +
            "Please re-check the batch allocation before saving:\n" +
            payload.ReconciliationErrors.join("\n"),
          "Validation Error"
        );
        return;
      }

      this.showLoading(true);

      try {
        const response = await MaterialIssuesService.saveMaterialIssue(payload);

        if (response) {
          this.$notify(
            `Material issues have been successfully saved.`,
            "success"
          );
        }

        this.$nextTick(() => {
          this.onHide();
          this.$emit("onRefreshDataList");
          this.$emit("onRefreshWorkOrderHeader");
        });
      } catch (error) {
        if (error && error.data && error.data.Errors) {
          if (
            Array.isArray(error.data.Errors) &&
            error.data.Errors[0].MessageType != undefined
          ) {
            this.displayLineCellError(
              error.data.Errors[0].Message,
              "Server Error"
            );
          } else {
            this.displayServerErrorOnTemplate(
              error,
              "Error saving material issue"
            );
          }
        } else {
          this.displayLineCellError(
            `Unable to save material issue. Please try again later.`,
            "Error"
          );
        }
      } finally {
        this.showLoading(false);
      }
    },

    async getPayloadData() {
      const payload = {
        IsAlmondcoMaterialIssue: this.WorkOrderInstance === "Almondco",
        // IssueNo: 0,
        // Username: "string",
        // WorkOrderCode: 0,
        BranchCode: this.model.BranchCode,
        DateIn: this.model.IssueDate.toSaveDate(),
        MaterialIssueDetails: [],
        ReconciliationErrors: [],
      };

      const materialIssueDetails = await this.issueDataSource.load({
        filter: [[["StockUMQty", "<>", 0], "or", ["Completed", "=", true], "or", ["ProductCode", "<>", null]]],
      });

      payload.MaterialIssueDetails = await Promise.all(
        materialIssueDetails.map(async (item) => {
          const isBatchControlled = item.IsBatchProduct != "No";
          const batchData = isBatchControlled
            ? await item.ChildDataSource.load({
                filter: [
                  ["IssuedQty", "<>", 0],
                  "and",
                  ["IsIncluded", "=", true],
                ],
              })
            : [];

          // For batch-controlled lines, the batch selection is the source of
          // truth for the issued quantity — not the separately-maintained
          // StockUMQty rollup, which can drift out of sync with it.
          const batchTotal = batchData
            .reduce((sum, batchItem) => sum + (batchItem.IssuedQty || 0), 0)
            .roundNumber(4);

          if (
            isBatchControlled &&
            (item.StockUMQty !== 0 || item.Completed) &&
            batchTotal !== item.StockUMQty
          ) {
            payload.ReconciliationErrors.push(
              `${item.ProductCode}: Issue Qty ${item.StockUMQty}, Batch Qty ${batchTotal}`
            );
          }

          return {
            WorkOrderCode: item.WorkOrderCode,
            ProcessCode: item.ProcessCode,
            ProductCode: item.ProductCode,
            IssueQty: isBatchControlled ? batchTotal : item.StockUMQty,
            Comment: item.Comment,
            Completed: item.Completed ? "Y" : "N",
            ProductionUMReleaseQty: item.ProductionUMReleaseQty,
            CardNo: item.BinCardNo,
            SeasonYear: item.SeasonYear,
            StorageLocationRecordId: item.StorageLocationRecordId,
            IssueType: item.IssueType,
            IssueTypeRecordId: item.IssueTypeRecordId,
            IsBatchProduct: item.IsBatchProduct,
            MaterialIssueBatches: batchData.map((batchItem) => {
              return {
                SupplierCode: batchItem.SupplierCode,
                BatchNo: batchItem.BatchNo,
                BatchQty: batchItem.IssuedQty,
              };
            }),
          };
        })
      );

      return payload;
    },

    getBatchDataSourceConfig(lineItem) {
      const lineData = lineItem.data;

      if (this.popupMode === "create") {
        return lineData.ChildDataSource;
      } else {
        return MaterialIssuesService.dataSourceConfig(
          "api/MaterialIssueProductBatch",
          {
            filter: `ItemCode eq '${
              lineData.ProductCode
            }' and WorkOrderCode eq ${parseInt(
              lineData.WorkOrderCode
            )} and MaterialIssue eq ${parseInt(
              lineData.MaterialIssueCode
            )} and MaterialIssueLineNo eq ${parseInt(lineData.LineNo)}`,
            postProcess: (data) => {
              data.forEach((item) => {
                item.ExpiryDate = item.BestBeforeDate || item.UseByDate;
              });

              return data;
            },
          }
        );
      }
    },

    // Data Grid
    getProcessCodeSource(rowInfo) {
      const data = rowInfo.data;
      return MaterialIssuesService.dataSourceConfig("api/WorkOrderLabour", {
        filter: [["WorkOrderCode", "=", data.WorkOrderCode]],
        key: "RecordId",
        keyType: {
          RecordId: "Guid",
        },
        paginate: true,
        select: ["RecordId", "ProcessCode", "WorkOrderCode"],
      });
    },
    setMaterialDataSource(rowInfo) {
      const data = rowInfo.data;
      if (
        this.WorkOrderInstance === "Almondco" &&
        data.IssueType === "Added In"
      ) {
        return ProductionReleaseService.dataSourceConfig(
          "api/WorkOrderAddInDistinctProduct",
          {
            filter: [["WorkOrderCode", "=", data.WorkOrderCode]],
          }
        );
      } else {
        let filter = [
          ["Inactive", "=", "N"],
          // "and",
          // ["IsBatchProduct", "<>", "No"],
        ];
        if (
          this.WorkOrderInstance === "Almondco" &&
          data.IssueType !== "Issue"
        ) {
          filter.push("and");
          filter.push(this.AlmondcoMaterialIssuesAttributeFilter);
        }
        return ProductionReleaseService.dataSourceConfig("api/Product", {
          filter: filter,
          select: [
            "Code",
            "Description1",
            "Description2",
            "Description3",
            "Attribute01",
            "Attribute02",
            "Attribute03",
            "Attribute04",
            "Attribute05",
            "Attribute06",
            "Attribute07",
            "Attribute08",
            "Attribute09",
            "Attribute10",
            "Attribute11",
            "Attribute12",
            "Attribute13",
            "Attribute14",
            "Attribute15",
            "Attribute16",
            "Attribute17",
            "Attribute18",
            "Attribute19",
            "Attribute20",
            "Inactive",
            "IsBatchProduct",
            "ProductTypeCode",
            "ProductCategory1Code",
            "ProductCategory2Code",
            "ProductCategory3Code",
            "ProductCategory4Code",
            "ProductSizeCode",
            "UnitOfMeasureCode",
          ],
        });
      }
    },

    commentFieldHeightUpdate(e) {
      let instance = e.component;
      let count = countLineBreaks(instance.instance().option().value);
      // Adjust the height of the comment field based on the number of line breaks
      // If there are less than 7 line breaks, set the height to count * 16
      // If there are 7 or more line breaks, set the height to 250px
      // This is to ensure that the comment field does not grow too large
      // and remains user-friendly.
      // The height is set to 16px per line break, with a maximum height of 250px
      if (count < 7) {
        if (count > 2) {
          instance.instance().beginUpdate();
          instance.instance().option("height", count * 16);
          instance.instance().endUpdate();
          this.dataGrid.updateDimensions();
        }
      } else {
        instance.instance().beginUpdate();
        instance.instance().option("height", 250);
        instance.instance().endUpdate();
        this.dataGrid.updateDimensions();
      }
    },

    async onWorkOrderValueChanged(e, rowInfo) {
      const selectedValue = e.value;

      let newData = {};
      const currentRowData = rowInfo.data;

      if (currentRowData.ProcessCode) {
        const confirmChanging = await this.$confirm(
          "Changing the Work Order will clear all fields for this entry. Do you wish to proceed?",
          "Change Work Order"
        );

        if (confirmChanging) {
          if (currentRowData.IsBatchProduct !== "No") {
            this.resetTransactionQtyOnBatchLines(currentRowData);
            // Clear the child data source if the work order is changed
            currentRowData.ChildDataSource.clear();
            this.dataGrid.collapseRow(currentRowData.ID);
            await this.$nextTick();
          }
          newData = {
            ...baseLine,
            ...{
              WorkOrderCode: selectedValue,
              ChildDataSource: new ArrayStore({
                key: "ID",
                data: [],
              }),
              IsBatchProduct: "No",
            },
          };

          this.issueDataSource.update(currentRowData.ID, newData);

          await this.$nextTick();

          // const rowIndex = this.dataGrid.getRowIndexByKey(currentRowData.ID);
          // setTimeout(() => {
          //   this.focusOnEditableCell(rowIndex, "ProcessCode");
          // }, 100);
        }
      } else {
        this.dataGrid.cellValue(
          rowInfo.rowIndex,
          rowInfo.column.dataField,
          selectedValue
        );
      }

      this.$nextTick(async () => {
        await this.addNextLineOnProductSelect(rowInfo.data);

        this.$nextTick(() => {
          var dataGrid = this.$refs["gc-popup-release-model-grid"].instance;
          dataGrid.saveEditData();
          dataGrid.refresh().then(() => {
            this.focusOnEditableCell(rowInfo.rowIndex, "ProcessCode");

            setTimeout(() => {
              // this.dataGrid.saveEditData();
              // this.dataGrid.collapseAll(-1);
              this.dataGrid.updateDimensions();
              // this.dataGrid.repaint();
            }, 100);
          });
        });
      });
    },
    async addNextLineOnProductSelect(rowInfo, refresh = false) {
      const items = await this.issueDataSource.load();
      const rowIndex = items.findIndex((x) => x.ID === rowInfo.ID);
      if (rowIndex + 1 === items.length) {
        this.issueDataSource.insert(baseLine);
      }

      if (refresh) {
        this.$nextTick(() => {
          var dataGrid = this.$refs["gc-popup-release-model-grid"].instance;
          dataGrid.saveEditData();
          dataGrid.refresh();
        });
      }
    },

    onLocationSearchClick(lineData) {
      this.slPopupConfig.rowInfo = lineData;
      this.slPopupConfig.visible = true;
    },
    onLocationCodeFocusIn() {
      this.ignoreLocationChangeEvent = false;
    },
    addSelectedStorageLocation(selectedStorageLocationArray, rowInfo = null) {
      if (selectedStorageLocationArray.length > 0) {
        this.ignoreLocationChangeEvent = true;
        this.issueDataSource.update(
          rowInfo ? rowInfo.data.ID : this.slPopupConfig.rowInfo.data.ID,
          {
            BinLocationCode: selectedStorageLocationArray[0].Code,
            StorageLocationRecordId: selectedStorageLocationArray[0].RecordId,
            LocationDescription: selectedStorageLocationArray[0].Name,
          }
        );

        this.$nextTick(() => {
          const dataGrid = this.dataGrid;
          dataGrid.saveEditData();
          setTimeout(() => {
            this.focusOnEditableCell(
              rowInfo ? rowInfo.rowIndex : this.slPopupConfig.rowInfo.rowIndex,
              "ProductCode"
            );
          }, 100);
        });
      }
    },

    async OnNewLocationValueChanged(e, rowInfo) {
      if (!e.value) {
        this.dataGrid.cellValue(
          rowInfo.rowIndex,
          rowInfo.column.dataField,
          e.value
        );
        return;
      }
      if (this.ignoreLocationChangeEvent) {
        this.ignoreLocationChangeEvent = false;
        return;
      }

      let result = await ProductAttributeService.checkStorageLocationExists(
        e.value
      );

      if (result && result.data.value.length == 0) {
        await this.$alert(
          `${e.value} is not a valid location.`,
          "Not a valid location"
        );
        setTimeout(() => {
          this.focusOnEditableCell(rowInfo.rowIndex, "BinLocationCode");
        }, 100);
      } else {
        this.addSelectedStorageLocation(result.data.value, rowInfo);
      }
    },
    async onProductValueChanged(e, rowInfo) {
      const selectedValue = e.value;
      const component = e.component; // the dxSelectBox instance
      const selectedItem = component
        .option("items")
        .find((item) => item.Code === selectedValue);

      const rowData = { ...rowInfo.data };

      this.resetTransactionQtyOnBatchLines(rowData);

      rowData.ChildDataSource = new ArrayStore({
        key: "ID",
        data: [],
      });

      this.dataGrid.collapseRow(rowData.ID);

      let dataSet = {
        ProductCode: e.value,
        ProductDescription: null,
        Conversion: 0,
        IsBatchProduct: "No",
        StockUM: null,
        StockUMQty: 0,
      };

      if (selectedItem) {
        dataSet = {
          ProductCode: e.value,
          ProductDescription: selectedItem.Description1,
          IsBatchProduct: selectedItem.IsBatchProduct,
          StockUM: selectedItem.UnitOfMeasureCode,
          StockUMQty: 0,
        };

        if (selectedItem.IsBatchProduct !== "No") {
          try {
            const batchData = await MaterialIssuesService.getAllBatchNo(
              `ItemCode eq '${selectedValue}'`,
              {
                select: [
                  "ItemCode",
                  "BranchCode",
                  "SourceTransactionType",
                  "SourceTransactionNo",
                  "SourceTransactionLine",
                  "SourceTransactionProcessCode",
                  "CompanyCode",
                  "SupplierCode",
                  "SupplierName",
                  "BatchNo",
                  "AllocatedQty",
                  "AvailableQty",
                  "OnHand",
                  "UseByDate",
                  "CurrentTransactionAllocatedQty",
                  "UseByShelfLife",
                  "BestBeforeShelfLife",
                  "BestBeforeDate",
                  "PickedUM",
                  "PickedUMConversion",
                  "AvailablePickedUMQty",
                  "ExpiryDate",
                  "ExpiryDateString",
                  "ExpiryMethod",
                  "ManufacturedDate",
                ],
              },
              this.model.BranchCode
            );

            if (batchData && batchData.data && batchData.data.value) {
              for (const batch of batchData.data.value) {
                let InTransactionQty = 0;
                const items = await this.issueDataSource.load({
                  filter: [
                    ["ProductCode", "=", selectedValue],
                    "and",
                    ["ID", "<>", rowData.ID],
                  ],
                });

                if (items && items.length > 0) {
                  for (const item of items) {
                    if (item.ChildDataSource && item.ChildDataSource._array) {
                      for (const child of item.ChildDataSource._array) {
                        if (child.BatchNo === batch.BatchNo) {
                          InTransactionQty += child.IssuedQty;
                        }
                      }
                    }
                  }
                }

                rowData.ChildDataSource.insert({
                  BatchNo: batch.BatchNo,
                  ExpiryDate: batch.BestBeforeDate || batch.UseByDate,
                  UseByDate: batch.UseByDate,
                  BestBeforeDate: batch.BestBeforeDate,
                  AvailableQty: batch.AvailableQty,
                  OnHand: batch.OnHand,
                  AllocatedQty: batch.AllocatedQty,
                  UseByShelfLife: batch.UseByShelfLife,
                  BestBeforeShelfLife: batch.BestBeforeShelfLife,
                  SupplierCode: batch.SupplierCode,
                  SupplierName: batch.SupplierName,
                  ItemCode: batch.ItemCode,
                  BranchCode: batch.BranchCode,
                  InTransactionQty: InTransactionQty,
                  RemainingQty: batch.AvailableQty - InTransactionQty,
                  IssuedQty: 0,
                  ParentID: rowData.ID,
                });
              }

              this.issueDataSource.update(rowData.ID, {
                ChildDataSource: rowData.ChildDataSource,
              });
            }
          } catch (error) {
            this.displayServerErrorOnTemplate(
              error,
              "Error fetching batch data. Please try again later."
            );
          }
        }
      }
      this.issueDataSource.update(rowData.ID, dataSet);

      this.$nextTick(async () => {
        // await this.addNextLineOnProductSelect(rowInfo.data);

        this.$nextTick(() => {
          this.dataGrid.saveEditData();
          this.dataGrid.refresh().then(() => {
            let dataField = "stockUMQty";
            if (selectedItem.IsBatchProduct !== "No") {
              dataField = "Comment";

              this.dataGrid.expandRow(rowData.ID);
            }
            this.focusOnEditableCell(rowInfo.rowIndex, dataField);
          });
        });
      });
    },

    onIssueTypeValueChanged(e, rowInfo) {
      const selectedValue = e.value;
      const component = e.component; // the dxSelectBox instance
      const selectedItem = component
        .option("items")
        .find((item) => item.MaterialIssueTypeName === selectedValue);

      const rowData = { ...rowInfo.data };

      if (selectedItem) {
        this.issueDataSource.update(rowData.ID, {
          IssueType: selectedItem.MaterialIssueTypeName,
          IssueTypeRecordId: selectedItem.RecordId,
        });
      }

      this.dataGrid.cellValue(
        rowInfo.rowIndex,
        rowInfo.column.dataField,
        selectedValue
      );
    },

    setFocusOnHeaderForm() {
      const form = this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;
      if (form) {
        form.getEditor("BranchCode").focus();
        this.removeGridFocusRow();
      }
    },

    /**
     * Remove Focus on DataGrid
     */
    removeGridFocusRow() {
      if (this.dataGrid) {
        this.dataGrid.option("focusedRowIndex", -1);
      }
    },

    updateLineErrorVisibility() {
      this.LineCellErrorVisible = !this.LineCellErrorVisible;
    },
    async displayLineCellError(errorMessage, errorTitle = "Validation Error") {
      if (!this.LineCellErrorVisible) {
        this.updateLineErrorVisibility();
        await this.$alert(errorMessage, errorTitle);
        this.updateLineErrorVisibility();
      }
    },
    getBatchGridInstance(ParentID) {
      if (this.$refs["master-details-" + ParentID]) {
        this.BatchGridInstance =
          this.$refs["master-details-" + ParentID].instance;
        return this.BatchGridInstance;
      } else return false;
    },
    focusOnBatchEditableCell(currentRowData, column = "IssuedQty") {
      const batchDataGrid = this.getBatchGridInstance(currentRowData.ParentID);
      const rowIndex = batchDataGrid.getRowIndexByKey(currentRowData.ID);
      const cellElement = batchDataGrid.getCellElement(rowIndex, column);
      batchDataGrid.focus(cellElement);

      setTimeout(() => {
        batchDataGrid.editCell(rowIndex, column);
      }, 10);
    },
    async onSelectionChanged(e) {
      this.batchSelectionPromise = this.processBatchSelectionChanged(e);
      await this.batchSelectionPromise;
    },

    async processBatchSelectionChanged(e) {
      const batchGrid = e.component;

      if (e.currentDeselectedRowKeys.length > 0) {
        for (const key of e.currentDeselectedRowKeys) {
          const item = await batchGrid.byKey(key);
          if (!item) continue;

          const parentItem = await this.dataGrid.byKey(item.ParentID);
          if (!parentItem) continue;

          // IsIncluded and IssuedQty must clear together — a gap here lets a
          // save slip through with a real IssueQty but no batch attribution.
          parentItem.ChildDataSource.update(key, {
            IsIncluded: false,
          });

          const rowIndex = batchGrid.getRowIndexByKey(key);
          const batchLine = await batchGrid.byKey(key);
          if (batchLine.IssuedQty != 0) {
            if (rowIndex !== -1) {
              batchGrid.cellValue(rowIndex, "IssuedQty", 0);
            }
          }
        }
      }

      if (e.currentSelectedRowKeys.length > 0) {
        for (const key of e.currentSelectedRowKeys) {
          const item = await batchGrid.byKey(key);
          if (!item) continue;

          const parentItem = await this.dataGrid.byKey(item.ParentID);
          if (parentItem) {
            parentItem.ChildDataSource.update(key, {
              IsIncluded: true,
            });
          }
        }
      }
    },

    onBatchIssuedQtyKeyDown(e, cellInfo) {
      if (e.event) {
        let data = cellInfo.data;
        let gridInstance = this.dataGrid;
        let batchGridInstance = this.getBatchGridInstance(data.ParentID);
        let items = batchGridInstance.getDataSource().items();
        let rowIndex = cellInfo.rowIndex;

        if (forwardTabbing(e)) {
          if (rowIndex == items.length - 1) {
            e.event.preventDefault();
            batchGridInstance.option("focusedRowIndex", -1);

            var gridDS = gridInstance.getDataSource();
            var loadOptions = gridDS.loadOptions();
            gridDS
              .store()
              .load(loadOptions)
              .done((loadedItems) => {
                let parentRowIndex = loadedItems.findIndex(
                  (x) => x.ID == data.ParentID
                );

                let nextRowIndex = parentRowIndex + 1;
                let nextRow = loadedItems[nextRowIndex];

                e.component.blur();

                setTimeout(() => {
                  if (nextRow) {
                    let dataField = "WorkOrderCode";
                    if (!this.IsWorkOrderEditable) {
                      dataField = "ProcessCode";
                    }
                    let rowIndex = gridInstance.getRowIndexByKey(nextRow.ID);
                    this.focusOnEditableCell(rowIndex, dataField);
                  }
                }, 10);
              });
          }
        } else if (backwardTabbing(e)) {
          if (rowIndex === 0) {
            e.event.preventDefault();
            gridInstance.option("focusedRowIndex", -1);
            let parentRowIndex = gridInstance.getRowIndexByKey(data.ParentID);

            this.focusOnEditableCell(parentRowIndex, "Completed");
          }
        }
      }
    },

    onWorkOrderKeyDown(e, cellInfo) {
      if (e.event) {
        let gridInstance = this.dataGrid;
        var gridDS = gridInstance.getDataSource();
        var loadOptions = gridDS.loadOptions();
        gridDS
          .store()
          .load(loadOptions)
          .done((loadedItems) => {
            let index = loadedItems.findIndex((x) => x.ID == cellInfo.data.ID);
            if (index != -1) {
              let prevLine = loadedItems[index - 1];
              if (prevLine.IsBatchProduct != "No") {
                e.event.preventDefault();
                gridInstance.option("focusedRowIndex", -1);
                gridInstance.expandRow(prevLine.LineNo).then(() => {
                  // Prev Items is Batch
                  setTimeout(() => {
                    this.moveIntoLastFieldInBatch(e, prevLine);
                  }, 100);
                });
              }
            }
          });
      }
    },

    moveIntoLastFieldInBatch(e, prevItem) {
      let gridInstance = this.dataGrid;
      gridInstance.expandRow(prevItem.ID).then(() => {
        let batchGridInstance = this.getBatchGridInstance(prevItem.ID);
        let items = batchGridInstance.getDataSource().items();

        if (items.length > 0) {
          e.event.preventDefault();

          let dataField = "IssuedQty";

          if (batchGridInstance) {
            let cellElement = batchGridInstance.getCellElement(
              items.length - 1,
              dataField
            );
            if (cellElement) {
              let rowIndex = batchGridInstance.getRowIndexByKey(
                items[items.length - 1].ID
              );
              batchGridInstance.focus(cellElement);
              setTimeout(() => {
                batchGridInstance.editCell(rowIndex, dataField);
              }, 1);
            }
          }
        }
      });
    },

    async focusOutFromEditableCells() {
      const items = await this.issueDataSource.load();

      for (let item of items) {
        if (
          item.ChildDataSource &&
          item.ChildDataSource._array &&
          item.ChildDataSource._array.length > 0
        ) {
          const batchGrid = this.getBatchGridInstance(item.ID);
          if (batchGrid) batchGrid.saveEditData();
        }
      }

      await this.$nextTick();

      const activeElement = document.activeElement;
      if (activeElement) {
        activeElement.blur();
        this.dataGrid.saveEditData();
      }
    },

    async reverseMaterialIssue(e) {
      this.showLoading(true);
      let lineData = e.row.data;

      try {
        const response = await MaterialIssuesService.reverseMaterialIssue({
          IsAlmondcoMaterialIssue: this.WorkOrderInstance === "Almondco",
          IssueNo: lineData.MaterialIssueCode,
          IssueLineNo: lineData.LineNo,
        });

        const dataGrid = this.$refs["gc-popup-release-model-grid"];
        if (response && dataGrid && dataGrid.instance) {
          this.reversalInitiated = true;
          dataGrid.instance.refresh();
        }

        this.$nextTick(() => {
          this.$notify(
            `Material Issue has been successfully reversed`,
            "success"
          );
        });
      } catch (error) {
        this.displayServerErrorOnTemplate(
          error,
          "Error reversing material issue"
        );
      } finally {
        this.showLoading(false);
      }
    },
  },
  computed: {
    ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    getTitle() {
      if (this.popupMode === "create") {
        return "Create Material Issues";
      } else {
        return "Issue #" + this.popupConfig.dataModel.IssueNo;
      }
    },
    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 3,
          items: [
            {
              label: {
                text: "Issue Date",
              },
              dataField: "IssueDate",
              editorType: "dxDateBox",
              editorOptions: {
                displayFormat: "dd MMM yyyy",
                width: 150,
                min: this.DateMin,
                max: this.DateMax,
                onFocusIn: (e) => {
                  e.event.target.select();
                },
              },
            },
            {
              screenField: "Branch",
              dataField: "BranchCode",
              label: {
                text: "Branch",
              },
              cssClass: "branch-field",
              editorOptions: {
                dropDownOptions: {
                  width: 200,
                },
                onFocusIn: (e) => {
                  e.event.target.select();
                },
                onKeyDown: (e) => {
                  if (forwardTabbing(e) && this.popupMode === "create") {
                    e.event.preventDefault();
                    const dataGrid = this.dataGrid;
                    if (this.issueDataSource._array.length > 0) {
                      let rowIndex = 0;
                      let dataField = this.IsWorkOrderEditable
                        ? "WorkOrderCode"
                        : "ProcessCode";
                      const cellElement = dataGrid.getCellElement(
                        rowIndex,
                        dataField
                      );
                      dataGrid.focus(cellElement);
                      dataGrid.editCell(rowIndex, dataField);
                    }
                  }
                },
              },
            },
          ],
        },
      ];
    },
    getFormModel() {
      return this.model;
    },
    getVisible() {
      if (this.popupConfig.isPopupShow) return this.popupConfig.isPopupShow;
      else return false;
    },
    getToolbarItems() {
      if (this.popupMode === "create") {
        return [
          {
            widget: "dxButton",
            location: "after",
            toolbar: "top",
            visible: true,
            options: {
              text: "Save",
              stylingMode: "contained",
              type: "default",
              onClick: this.onSaveProductionRelease,
            },
          },
          {
            widget: "dxButton",
            location: "after",
            toolbar: "top",
            visible: true,
            options: {
              text: "",
              icon: "close",
              stylingMode: "text",
              type: "default",
              onClick: this.onPopupClose,
            },
          },
        ];
      } else {
        return [
          {
            widget: "dxButton",
            location: "after",
            toolbar: "top",
            visible: true,
            options: {
              text: "",
              icon: "close",
              stylingMode: "text",
              type: "default",
              onClick: this.onPopupHide,
            },
          },
        ];
      }
    },
    getColumns() {
      return [
        {
          caption: "Work Order",
          dataType: "number",
          dataField: "WorkOrderCode",
          width: ColumnWidth.WorkOrder.width,
          maxWidth: ColumnWidth.WorkOrder.minWidth,
          cssClass: "edit-cell-textbox-field",
          editorType: "dxSelectBox",
          alignment: "left",
          editorOptions: {
            readonly: !this.IsWorkOrderEditable,
            dataSource: ProductionReleaseService.dataSourceConfig(
              "api/WorkOrderList",
              {
                filter: [
                  ["FriendlyStatus", "=", "Awaiting Production"],
                  "or",
                  ["FriendlyStatus", "=", "In Production"],
                  "or",
                  ["FriendlyStatus", "=", "Review"],
                ],
                sort: "Code desc",
              }
            ),
            displayExpr: "Code",
            valueExpr: "Code",
            searchTimeout: 10,
            searchEnabled: true,
            noDataText: "No eligible Work Orders available.",
            searchExpr: [
              "WorkOrderCodeSearchText",
              "ProductCode",
              "ProductDescription",
            ],
            // searchMode: "equals",
            dropDownOptions: {
              width: 300,
            },
            onFocusIn: (e) => {
              e.event.target.select();
            },
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete">
                    <span class="auto-complete-primary">
                      ${data.Code}
                    </span>
                    <span class="record-secondary gc-grid-code">
                      ${data.ProductCode} - ${data.ProductDescription.trim()}
                    </span>
                  </div>`;
            },
            onValueChanged: (e, lineData) => {
              this.onWorkOrderValueChanged(e, lineData);
            },
            // onItemClick: (e, lineData) => {
            //   if (e.event)
            //     this.focusOnEditableCell(lineData.rowIndex, "ProcessCode");
            // },
            onKeyDown: (e, lineData) => {
              if (backwardTabbing(e) && lineData.rowIndex === 0) {
                e.event.preventDefault();
                this.setFocusOnHeaderForm();
              } else if (backwardTabbing(e) && lineData.rowIndex > 0) {
                this.onWorkOrderKeyDown(e, lineData);
              } else if (forwardTabbing(e) && !lineData.data.WorkOrderCode) {
                e.event.preventDefault();
              }
            },
          },
          setCellValue: async (newData, value) => {
            newData.WorkOrderCode = value;
            return newData;
          },
          allowEditing: this.IsWorkOrderEditable,
        },
        {
          caption: "Process",
          dataField: "ProcessCode",
          minWidth: ColumnWidth.ProcessCode.minWidth,
          width: ColumnWidth.ProcessCode.width,
          cssClass: "edit-cell-textbox-field",
          editorType: "dxSelectBox",
          editorOptions: {
            onFocusIn: async (e, lineData) => {
              const selectBox = e.component;
              selectBox.option(
                "dataSource",
                this.getProcessCodeSource(lineData)
              );
              await this.$nextTick();
              setTimeout(() => {
                selectBox.focus();
                this.$nextTick(() => {
                  e.event.target.select();
                });
              }, 200);
            },
            valueExpr: "ProcessCode",
            displayExpr: "ProcessCode",
            searchTimeout: 10,
            searchEnabled: true,
            searchExpr: ["ProcessCode"],
            onItemClick: (e, lineData) => {
              if (e.event)
                this.focusOnEditableCell(lineData.rowIndex, "IssueType");
            },
            onKeyDown: (e, lineData) => {
              if (
                backwardTabbing(e) &&
                !this.IsWorkOrderEditable &&
                lineData.rowIndex === 0
              ) {
                e.event.preventDefault();
                this.setFocusOnHeaderForm();
              } else if (
                backwardTabbing(e) &&
                !this.IsWorkOrderEditable &&
                lineData.rowIndex !== 0
              ) {
                this.onWorkOrderKeyDown(e, lineData);
              }
            },
          },
          setCellValue: async (newData, value, currentRowData) => {
            newData.ProcessCode = value;

            await this.addNextLineOnProductSelect(currentRowData);
            return newData;
          },
        },
        {
          caption: "Issue Type",
          dataField: "IssueType",
          minWidth: ColumnWidth.IssueType.minWidth,
          width: ColumnWidth.IssueType.width,
          cssClass: "edit-cell-textbox-field",
          editorType: "dxSelectBox",
          editorOptions: {
            dataSource: ProductionReleaseService.dataSourceConfig(
              "api/ActiveMaterialIssueType",
              {
                filter:
                  this.WorkOrderInstance !== "Core" && this.WorkOrderInstance
                    ? [
                        ["WorkOrderInstance", "=", this.WorkOrderInstance],
                        "and",
                        ["IsEnabled", "=", "Y"],
                      ]
                    : [
                        ["WorkOrderInstance", "=", this.WorkOrderInstance],
                        "and",
                        ["IsEnabled", "=", "Y"],
                        "and",
                        ["IsSystemDefault", "=", "Y"],
                      ],
                sort: "Sequence asc",
              }
            ),
            valueExpr: "MaterialIssueTypeName",
            displayExpr: "MaterialIssueTypeName",
            dropDownOptions: {
              width: 120,
            },
            onFocusIn: (e) => {
              setTimeout(() => {
                this.$nextTick(() => {
                  e.event.target.select();
                });
              }, 200);
            },
            onItemClick: (e, lineData) => {
              if (e.event) {
                let dataField = "BinCardNo";
                // if (e.itemData.MaterialIssueTypeName === "Added In") {
                //   dataField = "BinLocationCode";
                // }
                this.focusOnEditableCell(lineData.rowIndex, dataField);
              }
            },
            // onKeyDown: (e, lineData) => {
            //   if (forwardTabbing(e)) {
            //     if (lineData.data.IssueType === "Added In") {
            //       e.event.preventDefault();
            //       this.focusOnEditableCell(
            //         lineData.rowIndex,
            //         "BinLocationCode"
            //       );
            //     }
            //   }
            // },
            onValueChanged: (e, lineData) => {
              this.onIssueTypeValueChanged(e, lineData);
            },
            searchEnabled: true,
          },
          setCellValue: async (newData, value, currentRowData) => {
            newData.IssueType = value;

            if (
              value === "Return to Stock" ||
              value === "Bi-Product" ||
              value === "Brown Reclaim" ||
              value === "White Reclaim" ||
              value === "Rubbish"
            ) {
              newData.SeasonYear = this.currentFiscalYear;
            } else {
              newData.SeasonYear = null;
            }

            newData.BinCardNo = null;
            newData.ProductCode = null;
            newData.ProductDescription = null;
            newData.BinLocationCode = null;
            newData.StockUMQty = 0;
            newData.StockUM = null;
            newData.Comment = null;
            newData.StorageLocationRecordId = null;
            newData.Completed = false;
            newData.ChildDataSource = new ArrayStore({
              key: "ID",
              data: [],
            });
            newData.IsBatchProduct = "No";

            if (currentRowData.IsBatchProduct !== "No") {
              this.resetTransactionQtyOnBatchLines(currentRowData);
              this.dataGrid.collapseRow(currentRowData.ID);
              this.issueDataSource.update(currentRowData.ID, newData);
              await this.$nextTick();
              const rowIndex = this.dataGrid.getRowIndexByKey(
                currentRowData.ID
              );

              if (rowIndex !== -1) {
                this.dataGrid.repaintRows([rowIndex]);
              }
              this.dataGrid.refresh();
            }
            return newData;
          },
        },
        {
          caption: "Card No",
          dataField: "BinCardNo",
          editorType: "dxNumberBox",
          minWidth: ColumnWidth.CardNo.minWidth,
          width: ColumnWidth.CardNo.width,
          cssClass: "edit-cell-numberbox-field",
          format: "###",
          alignment: "left",
          editorOptions: {
            format: "###",
            onFocusIn: (e) => {
              e.event.target.select();
            },
            max: 99999999999999999999,
            onInput: (e) => {
              const inputElement = e.event.target;
              if (inputElement.value.length > 10)
                inputElement.value = inputElement.value.slice(0, 10);
            },
            onKeyDown: (e, lineData) => {
              if (forwardTabbing(e)) {
                if (
                  lineData.data.IssueType !== "Issue" &&
                  lineData.data.IssueType !== "Added In"
                ) {
                  e.event.preventDefault();
                  this.focusOnEditableCell(
                    lineData.rowIndex,
                    "BinLocationCode"
                  );
                }
              }
            },
            onFocusOut: async (e, lineData) => {
              if (!e.event) return;

              const { IssueType } = lineData.data;
              const isCardNoEmpty = !e.component.option("value");

              if (
                IssueType !== "Issue" ||
                !isCardNoEmpty ||
                this.LineCellErrorVisible
              )
                return;

              const focusField = (field) =>
                setTimeout(
                  () => this.focusOnEditableCell(lineData.rowIndex, field),
                  100
                );

              if (this.WorkOrderInstance === "Almondco") {
                const confirm = await this.$confirm(
                  "You are attempting to issue material without providing a Card No. Are you sure you want to do this?",
                  "Confirmation"
                );
                confirm
                  ? focusField("SeasonYear")
                  : focusField(lineData.column.dataField);
              } else {
                await this.displayLineCellError(
                  "Card No is required",
                  "Validation Error"
                );
                focusField(lineData.column.dataField);
              }
            },
          },
          setCellValue: async (newData, value, currentRowData) => {
            const rowIndex = this.dataGrid.getRowIndexByKey(currentRowData.ID);

            if (value !== null) {
              const items = await this.issueDataSource.load({
                filter: [["BinCardNo", "=", value]],
              });

              if (items.length > 0) {
                await this.displayLineCellError(
                  `Card number ${value} has already been used in this transaction. Please enter a unique card number for this product.`,
                  "Validation Error"
                );

                newData.BinCardNo = currentRowData.BinCardNo; // Keep the old value
                setTimeout(() => {
                  this.focusOnEditableCell(rowIndex, "BinCardNo");
                }, 100);
              } else {
                const checkCardNoExists =
                  await MaterialIssuesService.AlmondcoDistinctCardNo(value);

                if (
                  !checkCardNoExists ||
                  checkCardNoExists.data.value.length === 0
                ) {
                  if (
                    currentRowData.IssueType === "Issue" ||
                    currentRowData.IssueType === "Added In"
                  ) {
                    newData.BinCardNo = null;
                    newData.SeasonYear = null;
                    newData.ProductCode = null;
                    newData.ProductDescription = null;
                    if (!this.LineCellErrorVisible) {
                      await this.displayLineCellError(
                        `${value} is not an available Card No.`,
                        "Invalid Card No"
                      );
                    }
                    setTimeout(() => {
                      this.focusOnEditableCell(rowIndex, "BinCardNo");
                    }, 100);
                  } else {
                    newData.BinCardNo = value;
                  }
                  return newData;
                } else {
                  if (
                    currentRowData.IssueType !== "Issue" &&
                    currentRowData.IssueType !== "Added In"
                  ) {
                    await this.displayLineCellError(
                      `Entered Card No. is already used. Please enter another card no.`,
                      "Validation Warning"
                    );
                    setTimeout(() => {
                      this.focusOnEditableCell(rowIndex, "BinCardNo");
                    }, 100);
                  } else {
                    if (checkCardNoExists.data.value.length > 1) {
                      await this.displayLineCellError(
                        `${value} has been found in multiple seasons. Please select appropriate season.`,
                        "Validation Warning"
                      );

                      newData.BinCardNo = value;
                      newData.SeasonYear = null;
                      newData.ProductCode = null;
                      newData.ProductDescription = null;
                      newData.StockUMQty = null;
                      newData.StockUM = null;
                      setTimeout(() => {
                        this.focusOnEditableCell(rowIndex, "SeasonYear");
                      }, 100);
                    } else {
                      const data = checkCardNoExists.data.value[0];

                      const productBatchStatus =
                        await MaterialIssuesService.getProductBatchStatus(
                          data.ProductCode
                        );
                      const isBatchControlled =
                        productBatchStatus &&
                        productBatchStatus.data.value.length > 0 &&
                        productBatchStatus.data.value[0].IsBatchProduct !==
                          "No";

                      if (isBatchControlled) {
                        newData.BinCardNo = null;
                        newData.SeasonYear = null;
                        newData.ProductCode = null;
                        newData.ProductDescription = null;
                        newData.StockUMQty = null;
                        newData.StockUM = null;

                        await this.displayLineCellError(
                          `${data.ProductCode} is a batch-controlled product and cannot be resolved via Card No. Please use the Material Code field to select this product and allocate batches directly.`,
                          "Batch-Controlled Product"
                        );
                        setTimeout(() => {
                          this.focusOnEditableCell(rowIndex, "BinCardNo");
                        }, 100);
                        return newData;
                      }

                      newData.BinCardNo = data.CardNo;
                      newData.SeasonYear = data.SeasonYear;
                      newData.ProductCode = data.ProductCode;
                      newData.ProductDescription = data.ProductDescription;
                      newData.StockUMQty = data.NetWeight;
                      newData.StockUM = data.UnitOfMeasureCode;

                      setTimeout(() => {
                        this.focusOnEditableCell(rowIndex, "SeasonYear");
                      }, 100);
                    }
                  }
                }
              }
            } else {
              newData.BinCardNo = value;

              newData.SeasonYear = null;
              newData.ProductCode = null;
              newData.ProductDescription = null;
              newData.StockUMQty = null;
              newData.StockUM = null;
            }

            return newData;
          },
          visible: this.isInstanceAlmondco,
        },
        {
          caption: "Year",
          dataField: "SeasonYear",
          minWidth: ColumnWidth.SeasonYear.minWidth,
          width: ColumnWidth.SeasonYear.width,
          cssClass: "edit-cell-numberbox-field",
          editorType: "dxNumberBox",
          alignment: "left",
          editorOptions: {
            onInput: (e) => {
              const inputElement = e.event.target;
              if (inputElement.value.length > 4)
                inputElement.value = inputElement.value.slice(0, 4);
            },
            onFocusIn: (e) => {
              e.event.target.select();
            },
            onKeyDown: (e, lineData) => {
              if (!(forwardTabbing(e) || onEnter(e))) return;

              const { IssueType, BinCardNo } = lineData.data;

              if (
                IssueType === "Issue" ||
                (IssueType === "Added In" && BinCardNo)
              ) {
                e.event.preventDefault();

                const targetField =
                  IssueType === "Issue" && this.isInstanceAlmondco && !BinCardNo
                    ? "ProductCode"
                    : "Comment";

                this.focusOnEditableCell(lineData.rowIndex, targetField);
              }
            },

            onFocusOut: async (e, lineData) => {
              if (e.event) {
                if (
                  (lineData.data.IssueType === "Issue" ||
                    (lineData.data.IssueType === "Added In" &&
                      lineData.data.BinCardNo)) &&
                  !e.component.option("value") &&
                  !this.LineCellErrorVisible
                ) {
                  if (lineData.data.BinCardNo) {
                    e.event.preventDefault();
                    await this.displayLineCellError(
                      "Year is required",
                      "Validation Error"
                    );
                    setTimeout(() => {
                      this.focusOnEditableCell(
                        lineData.rowIndex,
                        lineData.column.dataField
                      );
                    }, 100);
                  }
                }
              }
            },
          },
          setCellValue: async (newData, value, currentRowData) => {
            if (
              currentRowData.IssueType === "Issue" ||
              currentRowData.IssueType === "Added In"
            ) {
              const checkCardNoExists =
                await MaterialIssuesService.AlmondcoDistinctCardNo(
                  currentRowData.BinCardNo,
                  value
                );

              if (
                !checkCardNoExists ||
                checkCardNoExists.data.value.length === 0
              ) {
                newData.SeasonYear = null;
                newData.ProductCode = null;
                newData.ProductDescription = null;
                newData.StockUMQty = null;
                newData.StockUM = null;

                await this.displayLineCellError(
                  `${value} is not an available Season.`,
                  "Invalid Season"
                );
                setTimeout(() => {
                  this.focusOnEditableCell(
                    this.dataGrid.getRowIndexByKey(currentRowData.ID),
                    "SeasonYear"
                  );
                }, 100);
                return;
              } else {
                const data = checkCardNoExists.data.value[0];

                const productBatchStatus =
                  await MaterialIssuesService.getProductBatchStatus(
                    data.ProductCode
                  );
                const isBatchControlled =
                  productBatchStatus &&
                  productBatchStatus.data.value.length > 0 &&
                  productBatchStatus.data.value[0].IsBatchProduct !== "No";

                if (isBatchControlled) {
                  newData.SeasonYear = null;
                  newData.ProductCode = null;
                  newData.ProductDescription = null;
                  newData.StockUMQty = null;
                  newData.StockUM = null;

                  await this.displayLineCellError(
                    `${data.ProductCode} is a batch-controlled product and cannot be resolved via Card No. Please use the Material Code field to select this product and allocate batches directly.`,
                    "Batch-Controlled Product"
                  );
                  setTimeout(() => {
                    this.focusOnEditableCell(
                      this.dataGrid.getRowIndexByKey(currentRowData.ID),
                      "SeasonYear"
                    );
                  }, 100);
                  return;
                }

                newData.BinCardNo = data.CardNo;
                newData.SeasonYear = data.SeasonYear;
                newData.ProductCode = data.ProductCode;
                newData.ProductDescription = data.ProductDescription;
                newData.StockUMQty = data.NetWeight;
                newData.StockUM = data.UnitOfMeasureCode;

                setTimeout(() => {
                  this.focusOnEditableCell(
                    this.dataGrid.getRowIndexByKey(currentRowData.ID),
                    "Comment"
                  );
                }, 100);
              }
            } else {
              newData.SeasonYear = value;
            }

            return newData;
          },
          visible: this.isInstanceAlmondco,
        },
        {
          caption: "Location",
          dataField: "BinLocationCode",
          cssClass: "edit-cell-textbox-field location-code-field",
          allowEditing: true,
          width: ColumnWidth.LocationCode.width,
          maxWidth: ColumnWidth.LocationCode.minWidth,
          visible: this.WorkOrderInstance === "Almondco",
          editorOptions: {
            onFocusIn: (e) => {
              e.event.target.select();
              this.onLocationCodeFocusIn();
            },
            buttons: [
              {
                name: "search",
                location: "after",
                options: {
                  icon: "search",
                  onClick: (e, lineData) => {
                    if (e) {
                      this.onLocationSearchClick(lineData);
                    }
                  },
                  width: 25,
                  height: 25,
                },
              },
            ],
            onValueChanged: this.OnNewLocationValueChanged,
            onKeyDown: (e, lineData) => {
              if (backwardTabbing(e)) {
                if (lineData.data.IssueType === "Added In") {
                  let dataField = "BinCardNo";
                  if (lineData.data.BinCardNo) {
                    dataField = "SeasonYear";
                  }
                  e.event.preventDefault();
                  this.focusOnEditableCell(lineData.rowIndex, dataField);
                } else if (lineData.data.IssueType !== "Issue") {
                  e.event.preventDefault();
                  this.focusOnEditableCell(lineData.rowIndex, "BinCardNo");
                }
              }
            },
          },
          setCellValue: async (newData, value) => {
            newData.BinLocationCode = value;
            return newData;
          },
        },
        {
          caption: "Material",
          dataField: "ProductCode",
          minWidth: ColumnWidth.ProductCode.minWidth,
          width: ColumnWidth.ProductCode.width,
          cssClass: "edit-cell-textbox-field",
          editorType: "dxSelectBox",
          editorOptions: {
            displayExpr: "Code",
            valueExpr: "Code",
            searchTimeout: 10,
            searchEnabled: true,
            searchExpr: ["Code", "Description1"],
            onFocusIn: (e, lineData) => {
              const selectBox = e.component;
              selectBox.option(
                "dataSource",
                this.setMaterialDataSource(lineData)
              );

              setTimeout(() => {
                this.$nextTick(() => {
                  e.event.target.select();
                });
              }, 200);
            },
            onKeyDown: (e, lineData) => {
              if (forwardTabbing(e)) {
                if (lineData.data.IsBatchProduct !== "No") {
                  e.event.preventDefault();
                  this.focusOnEditableCell(lineData.rowIndex, "Comment");
                }
              } else if (backwardTabbing(e)) {
                if (this.isInstanceAlmondco && !lineData.data.BinCardNo) {
                  e.event.preventDefault();
                  this.focusOnEditableCell(lineData.rowIndex, "SeasonYear");
                }
              }
            },
            onValueChanged: (e, lineData) => {
              this.onProductValueChanged(e, lineData);
            },
            onItemClick: (e, lineData) => {
              if (e.event) {
                const selectedItem = e.itemData;
                setTimeout(() => {
                  let dataField = "StockUMQty";
                  if (selectedItem.IsBatchProduct !== "No") {
                    dataField = "Comment";
                  }
                  this.focusOnEditableCell(lineData.rowIndex, dataField);
                }, 100);
              }
            },
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete">
                    <span class="auto-complete-primary">
                      ${data.Code}
                    </span>
                    <span class="record-secondary gc-grid-code">
                      ${data.Description1.trim()}
                    </span>
                  </div>`;
            },
            dropDownOptions: {
              width: 200,
            },
          },
          setCellValue: async (newData, value) => {
            newData.ProductCode = value;
            return newData;
          },
        },
        {
          caption: "Description",
          dataField: "ProductDescription",
          minWidth: ColumnWidth.ProductDescription.minWidth,
          width: ColumnWidth.ProductDescription.width,
          allowEditing: false,
        },
        {
          caption: "Issued Qty",
          dataField: "StockUMQty",
          dataType: "number",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000",
          cssClass: "edit-cell-numberbox-field",
          editorOptions: {
            format: "##,###,###,###,##0.0000",
            onFocusIn: (e) => {
              e.event.target.select();
            },
          },
          cellTemplate: "Decimal",
          setCellValue: async (newData, value) => {
            newData.StockUMQty = value;

            return newData;
          },
        },
        {
          caption: "UM",
          dataField: "StockUM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth,
          width: ColumnWidth.UnitOfMeasure.width,
          allowEditing: false,
        },
        {
          caption: "Comment",
          dataField: "Comment",
          dataType: "string",
          minWidth: ColumnWidth.Comment.minWidth,
          // width: ColumnWidth.Comment.width,
          cssClass: "edit-cell-textbox-field comment-text",
          allowEditing: true,
          editorOptions: {
            onFocusIn: (e) => {
              e.event.target.select();
            },
            maxLength: 100,
            maxHeight: 103,
            // height: 30,
            valueChangeEvent: "input",
            onInput: (e) => {
              this.commentFieldHeightUpdate(e);
            },
            onInitialized: (e) => {
              this.commentFieldHeightUpdate(e);
            },
            onKeyDown: (e, lineData) => {
              if (!backwardTabbing(e)) return;

              const { IssueType, BinCardNo, IsBatchProduct } = lineData.data;

              if (
                this.isInstanceAlmondco &&
                (IssueType === "Issue" ||
                  (IssueType === "Added In" && BinCardNo))
              ) {
                e.event.preventDefault();

                if (IssueType === "Issue" && !BinCardNo) {
                  const targetField =
                    IsBatchProduct !== "No" ? "ProductCode" : "StockUMQty";
                  this.focusOnEditableCell(lineData.rowIndex, targetField);
                } else {
                  this.focusOnEditableCell(lineData.rowIndex, "SeasonYear");
                }
              } else if (IsBatchProduct !== "No") {
                e.event.preventDefault();
                this.focusOnEditableCell(lineData.rowIndex, "ProductCode");
              }
            },
          },
          customizeText: (e) => {
            if (e.value) return e.value.replaceAll("\n", "<br/>\r\n");
            else return "";
          },
          encodeHtml: false,
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class='comment-cell-template'>${info.text}</div>`);
          },
        },
        {
          caption: "Complete",
          dataField: "Completed",
          editorType: "dxCheckBox",
          width: 65,
          dataType: "boolean",
          calculateCellValue:
            this.popupMode === "create"
              ? undefined
              : (data) => {
                  return data.Completed === "Y" ? true : false;
                },
          setCellValue: async (newData, value) => {
            newData.Completed = value;
            return newData;
          },
          editorOptions: {
            onKeyDown: (e, lineData) => {
              if (forwardTabbing({ event: e })) {
                if (lineData.data.IsBatchProduct !== "No") {
                  e.preventDefault();

                  this.dataGrid.expandRow(lineData.data.ID).then(() => {
                    setTimeout(() => {
                      this.$nextTick(() => {
                        const batchGrid = this.getBatchGridInstance(
                          lineData.data.ID
                        );
                        if (batchGrid) {
                          const rowIndex = 0;
                          const cellElement = batchGrid.getCellElement(
                            rowIndex,
                            "IssuedQty"
                          );
                          batchGrid.focus(cellElement);
                          batchGrid.editCell(rowIndex, "IssuedQty");
                        }
                      });
                    }, 100);
                  });
                }
              }
            },
          },
        },
        {
          dataField: "",
          caption: "",
          type: "buttons",
          buttons: [
            {
              hint: "Reversal",
              icon: "repeat",
              visible: (e) => {
                const data = e.row.data;
                if (data && data.WorkOrderFriendlyStatus === "Completed") {
                  return false;
                }

                if (
                  (data && data.Reversed === "Y") ||
                  this.popupMode === "create"
                ) {
                  return false;
                } else {
                  return true;
                }
              },
              onClick: async (e) => {
                let confirmReverse = await this.$confirm(
                  "Are you sure you want to reverse this material issue?",
                  "Reversal Confirmation"
                );

                if (confirmReverse) this.reverseMaterialIssue(e);
              },
            },
            {
              name: "Delete Row",
              icon: "trash",
              visible: this.popupMode === "create",
              onClick: async (e) => {
                const confirmDelete = await this.$confirm(
                  "Are you sure you want to remove this line?",
                  "Delete Entry"
                );
                if (confirmDelete) {
                  this.dataGrid.deleteRow(e.row.rowIndex);
                }
              },
            },
          ],
          fixed: true,
          fixedPosition: "right",
          width: 40,
          minWidth: 40,
          visible: this.getUserAccess,
        },
      ];
    },
    getUserAccess() {
      return FeatureStorage.checkPermission("WorkOrderMaterialIssue", "create");
    },

    getDataSourceConfig() {
      if (this.popupMode === "create") {
        return this.issueDataSource;
      } else {
        return MaterialIssuesService.dataSourceConfig(
          "api/MaterialIssueDetail",
          {
            filter: `MaterialIssueCode eq ${parseInt(
              this.popupConfig.dataModel.IssueNo
            )}`,
          }
        );
      }
    },
    getGridHeight() {
      return 570;
    },

    dataGrid() {
      return this.$refs["gc-popup-release-model-grid"].instance;
    },
    isInstanceAlmondco() {
      return this.WorkOrderInstance === "Almondco";
    },

    // Batch Grid
    getChildGridColumns() {
      return [
        {
          caption: "Batch",
          dataField: "BatchNo",
          minWidth: ColumnWidth.BatchNo.minWidth,
          width: ColumnWidth.BatchNo.width,
          allowEditing: false,
        },
        {
          caption: "Supplier",
          dataField: "SupplierCode",
          // minWidth: ColumnWidth.SupplierCode.minWidth,
          width: "auto",
          minWidth: 150,
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class="custom-auto-complete">
                        <span class="auto-complete-primary">
                          ${info.data.SupplierName}
                        </span> <br />
                      <span class="record-secondary gc-grid-code">
                        ${info.data.SupplierCode}
                      </span>
                    </div>`);
          },
          allowEditing: false,
        },
        {
          caption: "Use By / Best Before",
          dataField: "ExpiryDate",
          dataType: "date",
          minWidth: ColumnWidth.Date.minWidth,
          width: ColumnWidth.Date.width,
          format: "dd MMM yyyy",
          allowEditing: false,
        },
        {
          caption: "Available",
          dataField: "AvailableQty",
          dataType: "number",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000",
          cellTemplate: "Decimal",
          allowEditing: false,
        },
        {
          caption: "In Transaction",
          dataField: "InTransactionQty",
          dataType: "number",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000",
          cellTemplate: "Decimal",
          visible: this.popupMode === "create",
          allowEditing: false,
        },
        {
          caption: "Remaining",
          dataField: "RemainingQty",
          dataType: "number",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000",
          cellTemplate: "Decimal",
          visible: this.popupMode === "create",
          allowEditing: false,
        },
        {
          caption: "Issued Qty",
          dataField: "IssuedQty",
          dataType: "number",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000",
          cssClass: "edit-cell-numberbox-field",
          cellTemplate: "Decimal",
          editorOptions: {
            format: "##,###,###,###,##0.0000",
            onFocusIn: (e) => {
              if (e && e.event) {
                e.event.target.select();
              }
              this.dataGrid.option("focusedRowIndex", -1);
            },
            onKeyDown: this.onBatchIssuedQtyKeyDown,
            valueChangeEvent: "input",
          },
          setCellValue: async (newData, value, currentRowData) => {
            if (
              value !== null &&
              value &&
              value > currentRowData.RemainingQty
            ) {
              await this.displayLineCellError(
                `${
                  currentRowData.BatchNo
                } has an issued quantity of ${formatNumber(
                  value,
                  "##,###,###,###,##0.0000"
                )}, which is greater than the batch remaining quantity of ${formatNumber(
                  currentRowData.RemainingQty,
                  "##,###,###,###,##0.0000"
                )}.
                Please update the batch allocated quantity so that it is less than or equal to ${formatNumber(
                  currentRowData.RemainingQty,
                  "##,###,###,###,##0.0000"
                )}.`
              );

              newData.IssuedQty = currentRowData.IssuedQty;
              setTimeout(() => {
                this.focusOnBatchEditableCell(currentRowData, "IssuedQty");
              }, 100);
            } else {
              this.dataGrid
                .byKey(currentRowData.ParentID)
                .then(async (rowInfo) => {
                  if (rowInfo) {
                    rowInfo.StockUMQty =
                      rowInfo.StockUMQty - currentRowData.IssuedQty + value;

                    await this.$nextTick();
                    setTimeout(() => {
                      this.issueDataSource
                        .update(currentRowData.ParentID, {
                          StockUMQty: rowInfo.StockUMQty,
                        })
                        .then(() => {
                          this.dataGrid.refresh(true);
                        });
                    }, 1);
                  }
                });

              const items = await this.issueDataSource.load({
                filter: [
                  ["ProductCode", "=", currentRowData.ItemCode],
                  "and",
                  ["ID", "<>", currentRowData.ParentID],
                ],
              });

              if (items.length > 0) {
                for (const item of items) {
                  if (item.IsBatchProduct != "No") {
                    const batchItems = await item.ChildDataSource.load({
                      filter: [
                        ["BatchNo", "=", currentRowData.BatchNo],
                        "and",
                        ["SupplierCode", "=", currentRowData.SupplierCode],
                      ],
                    });

                    if (batchItems.length > 0) {
                      item.ChildDataSource.update(batchItems[0].ID, {
                        InTransactionQty:
                          batchItems[0].InTransactionQty != 0
                            ? batchItems[0].InTransactionQty -
                              currentRowData.IssuedQty +
                              value
                            : value,
                        RemainingQty:
                          batchItems[0].RemainingQty +
                          currentRowData.IssuedQty -
                          value,
                      });
                      await this.$nextTick();
                    }
                  }
                }
              }

              newData.IssuedQty = value;
            }

            const batchInstance = this.getBatchGridInstance(
              currentRowData.ParentID
            );
            if (batchInstance) {
              if (newData.IssuedQty > 0)
                batchInstance.selectRows([currentRowData.ID], true);
              else {
                batchInstance.deselectRows([currentRowData.ID]);
              }
            }

            return newData;
          },
          allowEditing: this.popupMode === "create",
        },
      ];
    },
  },
  watch: {
    getHotKeySave: {
      handler(val) {
        if (val) {
          this.$store.dispatch("hotKey/setHotKeySave", false);
          if (this.popupMode !== "review") {
            this.onSaveProductionRelease();
          }
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
.gc-popup-work-order-release-model {
  // .dx-datagrid-rowsview .dx-master-detail-row > .dx-master-detail-cell {
  //   // padding: unset !important;
  //   margin-bottom: 20px !important;
  // }
  .dx-datagrid-rowsview {
    .dx-editor-cell .dx-texteditor .dx-placeholder::before {
      padding-left: unset;
      padding-top: unset;
      padding-bottom: unset;
    }

    .edit-cell-template-field {
      .dx-textbox.dx-texteditor.dx-editor-underlined {
        border-bottom: 1px solid rgba(0, 0, 0, 0.42) !important;
      }
    }

    tr td {
      vertical-align: top !important;
    }

    .dx-datagrid-checkbox-size {
      vertical-align: top !important;
    }
  }
  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    .edit-cell-template-field.dx-editor-cell {
    padding-left: 5px !important;
  }

  .dx-datagridßå
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    .edit-cell-numberbox-field.dx-editor-cell {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    .edit-cell-textbox-field.dx-editor-cell {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }

  .location-code-field {
    .dx-texteditor-buttons-container {
      background-color: #03a9f4;

      .dx-icon-search::before {
        color: #fff !important;
      }
    }

    .dx-button.dx-button-has-icon:not(.dx-button-has-text):not(
        .dx-shape-standard
      ) {
      border-radius: unset !important;
    }
  }

  .dx-row.dx-data-row {
    td.required-field {
      // background-color: #ff00003b !important;
      .dx-texteditor:not(.dx-state-readonly)::after {
        content: "";
        border-bottom: 2px solid rgb(255 0 0) !important;
      }
    }
  }
}
</style>
